import moment from 'moment';

// Table cols for Assemblies and Parts Table
export default {
	defaultSortField: 'name',
	defaultSortOrder: 'asc',
	rearrangeCols: false,
	isCheckable: false,
	// stickeyHeaders: true,
	gutterOpts: {
		buttons: [
			// {
			//   event: 'columnChooser',
			//   icon: 'icon-tablecolumns',
			//   tooltip: 'Customize Columns',
			//   isLine: true,
			// }
		],
	},
	toolBar: {
		buttons: [
			{  
                label: 'History',
                event: 'activity',
                icon: 'icon-activityhistory',
            },
			{
				event: "addNew",
				icon: "icon-addnew",
				isLine: true,
				tooltip: "Add New",
				permissionModule: 'app&projects',
				alterDataKey: 'alterProject',
			},
			{
				event: 'importLocation',
				icon: 'icon-clone',
				tooltip: 'Import Company Locations',
				isLine: true,
				permissionModule: 'app&projects',
				alterDataKey: 'alterProject',
			}
		],
		bulkActions: () => { },
	},
	fields: [
		{
			title: 'Location Name',
			name: 'name',
			width: '400px',
			id: 'name',
			sortField: 'name',
			prop: 'name',
			defaultVisible: true,
		},
		{
			title: 'Owner',
			name: 'owner',
			width: '256px',
			id: 'owner',
			prop: 'owner',
			sortField: 'owner',
			defaultVisible: true,
		},
		{
			name: 'street',
			width: '152px',
			title: 'Street',
			id: 'street',
			prop: 'street',
			sortField: 'street',
			defaultVisible: true,
		},
		{
			name: 'city',
			width: '192px',
			title: 'City',
			id: 'city',
			sortField: 'city',
			prop: 'city',
			defaultVisible: true,
		},
		{
			name: 'state',
			sortField: 'state',
			width: '192px',
			title: 'State',
			id: 'state',
			prop: 'state',
			defaultVisible: true,
		},
		{
			name: 'zip',
			sortField: 'zip',
			width: '192px',
			title: 'Zip',
			id: 'zip',
			prop: 'zip',
			defaultVisible: true,
		},
		{
			name: 'location_type',
			width: '192px',
			sortField: 'location_type',
			title: 'Type',
			id: 'location_type',
			defaultVisible: true,
			prop: 'location_type',
			formatter: (value) => {
				if (value) {
					return value.join(', ');
				}
				return '';
			},
		},
		{
			name: 'defaultInventoryLocation',
			title: 'Project Inventory Default',
			prop: 'defaultInventoryLocation',
			id: 'default_location',
			width: '256px',
		},
		{
			title: 'Actions',
			name: 'table-field-actions',
			id: 'action',
			hideFromChooser: true,
			alwaysVisible: false,
			defaultVisible: true,
			width: '112px',
			// sticky: true,
			// clearBtn: true,
			// searchable: true,
			// hideAllFilters: false,
			permissionModule: 'app&projects',
			permissionKey: 'assembly_parts',
			// thAttrs: () => ({ class: 'action-sticky' }),
			// tdClass: 'action-sticky',
			inputProps: {
				showEdit: true,
				groupButtons() {
					return [
						{
							icon: "icon-edit",
							event: "edit",
							tooltip: "Edit",
							permissionModule: 'app&projects',
							alterDataKey: 'alterProject',
						},
						{
							icon: "icon-bin",
							event: "delete",
							tooltip: "delete",
							disabled(row) {
								return row.canDelete;
							},
							permissionModule: 'app&projects',
							alterDataKey: 'alterProject',
						},
					];
				},
			},
		},
	],
};
